<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.billingpreferences') }}
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <BaseFormBillingPreference
        :state="state"
        @onSubmit="handleSubmit"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import sidebarModule from './../../sidebarModule'

export default {
  data () {
    return {
      loading: true,
      isSubmitted: false,
      state: {
        is_enabled_monthly_invoice_charge: undefined,
        is_enabled_receive_invoice_email: undefined,
        is_enabled_receive_invoice_notification_desktop: undefined,
      },
    }
  },

  computed: {
    ...mapGetters({
      getBillingPreferenceSetting: 'getBillingPreferenceSetting',
    }),
  },

  beforeMount () {
    this.initPage({
      section: 'app',
      name: this.$t('app.billing.title'),
      current: {
        app_name: 'billing',
        app_id: null,
      },
    })
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 4,
    })
  },

  async mounted () {
    await this.$store.dispatch('setLocalStorageShopInfo')

    this.setState()
    this.loading = false
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
  },

  methods: {
    ...mapActions('billing', {
      updateBillingPreference: 'updateBillingPreference',
    }),
    setState () {
      this.state.is_enabled_monthly_invoice_charge = this.getBillingPreferenceSetting.is_enabled_monthly_invoice_charge
      this.state.is_enabled_receive_invoice_email = this.getBillingPreferenceSetting.is_enabled_receive_invoice_email
      this.state.is_enabled_receive_invoice_notification_desktop = this.getBillingPreferenceSetting.is_enabled_receive_invoice_notification_desktop
    },
    async handleSubmit (data) {
      const result = await this.updateBillingPreference(data)
      if (result.success) {
        this.notify(this.$vs, {
          text: this.$t('message.saved'),
          color: 'success',
          icon: 'cloud',
        })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/billing/preference/Index.vue